export function required(value) {
    return value ? undefined : 'Required';
}

export function validEmail(value) {
    return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? 'Invalid email address'
        : undefined;
}

export const isNumber = (value) =>
    value && Number.isNaN(Number(value)) ? 'Must be a number' : undefined;
